import { CONSENT_COOKIE, cookieValue, parseConsent, type Consent } from "./consent";

let active: Consent | null = null;
export function activateConsent(consent: Consent | null) { active = consent; }
export function hasConsent(category: "analytics" | "advertising"): boolean {
  if (typeof document === "undefined" || !active) return false;
  const saved = parseConsent(cookieValue(document.cookie, CONSENT_COOKIE));
  return Boolean(saved && saved.revision === active.revision && active[category] && saved[category]);
}

/** Remove only inventoried optional storage. Never clear all cookies/storage. */
export function clearOptionalStorage() {
  const cookieNames = document.cookie.split(";").map(p => p.trim().split("=")[0] ?? "")
    .filter(n => ["ft_aid_pub", "dub_id", "__obref", "__oppref"].includes(n) || /^ph_.*_posthog$/.test(n));
  const host = location.hostname;
  const domains = ["", `; Domain=${host}`, ...(host === "mlx.systems" || host.endsWith(".mlx.systems") ? ["; Domain=.mlx.systems"] : [])];
  for (const name of cookieNames) for (const domain of domains) {
    document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax; Secure${domain}`;
  }
  try {
    for (const key of Object.keys(localStorage)) {
      if (["mlx:first-touch", "mlx:last-touch", "tallie:first-touch", "tallie:last-touch"].includes(key) || /^ph_.*_posthog$/.test(key)) localStorage.removeItem(key);
    }
    for (const key of Object.keys(sessionStorage)) {
      if (key === "mlx:web-session-started" || key.startsWith("oaiq_cs:")) sessionStorage.removeItem(key);
    }
  } catch { /* Storage may be unavailable; consent still fails closed. */ }
}
